import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ProductImage } from "@/components/ProductCard";
import { Badge } from "@/components/ui/badge";
import { toPlainText } from "@/components/RichText";

export function CommercialCard({ product, image, onEnquire }) {
  return (
    <div className="flex flex-col rounded-2xl border border-brand-navy/10 bg-white overflow-hidden transition-transform duration-200 hover:-translate-y-1" data-testid={`commercial-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block relative bg-brand-white">
        {image ? (
          <img src={image} alt={product.name} loading="lazy" className="w-full h-56 object-cover" />
        ) : (
          <ProductImage src={null} alt={product.name} className="w-full h-56" />
        )}
      </Link>
      <div className="flex flex-col flex-1 p-6">
        {product.brand && <span className="text-[11px] font-mono-spec uppercase tracking-widest text-brand-navy">{product.brand}</span>}
        <Link to={`/product/${product.slug}`}>
          <h3 className="mt-1 font-display font-semibold text-xl text-brand-ink hover:text-brand-navy transition-colors">{product.name}</h3>
        </Link>
        <p className="mt-2 text-sm text-muted-foreground flex-1 line-clamp-5">{toPlainText(product.positioning)}</p>
        <div className="mt-5 flex gap-2">
          <Button asChild variant="outline" className="flex-1 border-brand-navy/30 text-brand-navy hover:bg-brand-navy hover:text-white">
            <Link to={`/product/${product.slug}`} data-testid={`commercial-view-${product.slug}`}>Details</Link>
          </Button>
          <Button onClick={() => onEnquire(product)} className="flex-1 bg-brand-navy hover:bg-brand-navy/90 text-white font-semibold" data-testid={`commercial-enquire-${product.slug}`}>
            Enquire
          </Button>
        </div>
      </div>
    </div>
  );
}
